<template>
  <div class="formDetail">
    <component :is="businessForm" class="create" ref="businessForm" :list="floderData" :openDia="1" />
    <el-table v-if="floderData.length > 0" :data="floderData" :show-header="false" max-height="200px">
        <el-table-column label="名称" prop="fileName">
          <template slot-scope="scope">
            <div style="width: 100%; display: flex; align-items: center">
              <img v-if="scope.row.isFolder != 1" :src="className(scope.row)" class="img" alt="" />
              <span style="width: 80%;cursor: pointer;" @click="preview(scope.row)">{{ scope.row.fileName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120px">
          <template slot-scope="scope">
            <span style="width: 100%; display: flex; justify-content: flex-start">
              <i class="el-icon-download" title="下载1" style="margin-right: 15px; color: #5584ff"
                @click="uploadRowType(scope.$index, floderData)" />
            </span>
          </template>
        </el-table-column>
    </el-table>
    <applicationFlow ref="applicationFlow" />
  </div>
</template>

<script>
import xunshi from '@/views/project/quaMange/modules/xunshi.vue';
import pangzhan from '@/views/project/quaMange/modules/pangzhan.vue';
import parallel from '@/views/project/quaMange/modules/parallel.vue';
import inspect from '@/views/project/quaMange/modules/inspect.vue';
import material from '@/views/project/quaMange/modules/material.vue';

import aqxj_pz from "@/views/project/quaMange/modules/aqxj_pz.vue";
import aqxj_zjc from "@/views/project/quaMange/modules/aqxj_zjc.vue";
import aqxj_aqys from "@/views/project/quaMange/modules/aqxj_aqys.vue";
import aqxj_aqxs from "@/views/project/quaMange/modules/aqxj_aqxs.vue";
import blankFlowForm from '@/CommonDP/pages/components/launchFlow/modules/blankFlowForm.vue';
import applicationFlow from '@/CommonDP/pages/components/launchFlow/components/applicationFlow.vue';
import flowService from "@/CommonDP/service/flow-service";
import quaMange from "@/xgzdService/quaMange-service"
import { tableRowIcon } from '@/CommonDP/utils/docPublic';
import xtDesign from '@/CommonDP/service/integratedModel-service';
import { noLabelFilePreview } from '@/CommonDP/utils/docPublic';
import { downloadFile, downloadUrltoken } from '@/CommonDP/utils';
import { mapState } from 'vuex';
export default {
  components:{xunshi,pangzhan,parallel,inspect,material,aqxj_pz,aqxj_zjc,aqxj_aqys,aqxj_aqxs,blankFlowForm,applicationFlow},
  data(){
    return{
      floderData:[],
      businessForm: '',//动态组件
    }
  },
  computed:{
    ...mapState({
       prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerParams: (state) => state.projectMg.routerParams,
    }),
     mapComponentName() {
      if (this.routerParams.flowKey) {
        if (this.routerParams.flowKey === "xunshi") {
          return "xunshi"
        }else if (this.routerParams.flowKey === "pangzhan") {
          return "pangzhan"
        }else if (this.routerParams.flowKey === "parallel") {
          return "parallel"
        }else if (this.routerParams.flowKey === "inspect") {
          return "inspect"
        }else if (this.routerParams.flowKey === "material") {
          return "material"
        }else if (this.routerParams.flowKey === "aqxj_pz") {
          return "aqxj_pz"
        }else if (this.routerParams.flowKey === "aqxj_zjc") {
          return "aqxj_zjc"
        }else if (this.routerParams.flowKey === "aqxj_aqys") {
          return "aqxj_aqys"
        }else if (this.routerParams.flowKey === "aqxj_aqxs") {
          return "aqxj_aqxs"
        } else {
          return 'blankFlowForm'
        }
      } else {
        return 'blankFlowForm'
      }
    },
  },

  methods:{
     async getInit() {
      this.businessForm = this.mapComponentName;
      await this.getProcessDetail()
      await this.getBusinessForm()
    },
    async getProcessDetail() {
      const res = await flowService.detail(this.routerParams.flowBusinessId);
      this.$refs.applicationFlow.setNodeList(res.data)
    },
    // 查询业务表单
    async getBusinessForm() {
      const res = await quaMange.getBusinessForm(this.routerParams.flowInstanceId);
      this.floderData = res.data.fileInfoList || [];
      this.$refs.businessForm.setFormData(res.data.object || {});
    },
    className(row) {
      return tableRowIcon(row);
    },
    async preview(row){
      const {prjId} = this.prjInfo;
       // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prjName = prjList.filter((item) => { 
        if (item.prjId === prjId) return item.prjName; 
      })[0]?.prjName;
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.versionIds,
        fileType: row.fileType,
        status: row.status
      };
      noLabelFilePreview(value, prjId, prjName, 'ct', 'yes');
    },
    async getprjList() {
      const param = {
        enterpriseId: this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    },
    uploadRowType(index, row) {
      const prjId = this.prjInfo.prjId;
      const fileId = row[index].fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      downloadFile(fileUrl);
    },
  }
}
</script>

<style lang="less" scoped>
.formDetail{
  background: #fff;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 0;
  .create {
    padding: 0 10px;
  }
  .check{
    padding: 5px 20px;
  }
}
</style>
